// extracted by mini-css-extract-plugin
export default {"status":"styles_status__18eIv"};